import { WindowActionType } from '@mode/legacy/util-domain';

export namespace WindowActions {
  export const Type = WindowActionType;

  export class EnterFullscreen {
    type: WindowActionType.EnterFullscreen = Type.EnterFullscreen;

    constructor(public element: Element) {}
  }

  export class EnterFullscreenFailure {
    type: WindowActionType.EnterFullscreenFailure = Type.EnterFullscreenFailure;
    constructor(public error: Error) {}
  }

  export class EnterFullscreenSuccess {
    type: WindowActionType.EnterFullscreenSuccess = Type.EnterFullscreenSuccess;
  }

  export class ExitFullscreen {
    type: WindowActionType.ExitFullscreen = Type.ExitFullscreen;
  }
}

export type WindowActions =
  | WindowActions.EnterFullscreen
  | WindowActions.EnterFullscreenFailure
  | WindowActions.EnterFullscreenSuccess
  | WindowActions.ExitFullscreen;
